<template>
    <Modal
      :show.sync="isOpen"
      :on-close="onClose"
    >
        <div>
            <h3 class="modal_header">{{$t('CAMPAIGN.LLM_CHATBOT.ADD.DYNAMIC_VAR.MODAL_TITLE')}}</h3>
        </div>
        <section class="main_modal_container modal_contentbox_height" style="overflow-x:hidden;">
        <div class="mt_24"></div>
            <MultiselectDropdown
                v-for="(item,i) in localDynamicVar"
                :key="i"
                :label="''"
                :classNameLabel="''"
                :error="$v.localDynamicVar.$each[i].$error  ? $t('CAMPAIGN.LLM_CHATBOT.ADD.DYNAMIC_VAR.OPTION.VAR_SELECT_ERR'):''"
              >
              <div class="row">
                <multiselect
                    class="column small-10"
                    v-model="localDynamicVar[i]"
                    :options="getFilteredOptions(i)"
                    track-by="name"
                    label="name"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :hide-selected="true"
                    :placeholder="$t('CAMPAIGN.LLM_CHATBOT.ADD.DYNAMIC_VAR.OPTION.PLACEHOLDER')"
                    selected-label
                    :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
                    :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
                    :append-to-body="true"
                    :maxHeight="200"
                />
                <div class="column small-2 delete_var">
                    <!-- <span @click.stop="onDeleteVariable(i)">
                    <fluent-icon icon="delete" />
                    </span> -->
                    <woot-button
                        variant="smooth"
                        size="medium"
                        color-scheme="secondary"
                        icon="delete"
                        class-names="grey-btn btn-width-auto"
                        @click="onDeleteVariable(i)"
                        >
                        </woot-button>
                </div>

                </div>
              </MultiselectDropdown>

            <div class="filter-actions" v-if="showAppendBtn">
                <woot-button
                    icon="add"
                    variant="smooth"
                    size="small"
                    @click="appendNewItem"
                >
                    {{ $t('CAMPAIGN.LLM_CHATBOT.ADD.DYNAMIC_VAR.ADD_ATTR') }}
                </woot-button>
            </div>

            <div class="mt_24">
                <woot-button
                    color-scheme="primary"
                    variant="solid"
                    size="small"
                    @click="onSave"
                >
                    {{$t('CAMPAIGN.LLM_CHATBOT.ADD.EVALUTION.BTN.ADD')}}
                </woot-button>
            </div>

        </section>



    </Modal>
</template>

<script>
import Modal from "dashboard/components/Modal.vue";
import InputField from "components/ui/inputs/InputField.vue";
import InputCard from "components/ui/inputs/InputCard.vue";
import { required, minLength, url, requiredIf } from 'vuelidate/lib/validators';
import WootButton from '../../../../../components/ui/WootButton.vue';
import { mapGetters } from 'vuex';
import MultiselectDropdown from "components/ui/inputs/MultiselectDropdown.vue";

export default {
    components:{
        Modal,
        InputField,
        InputCard,
        WootButton,
        MultiselectDropdown,
    },
    props:{
        isOpen: {
            type: Boolean,
            default: false,
        },
        onClose: {
            type: Function,
            default: () => {},
        },
        dataList: {
            type: Array,
            default: () => [],
        },
    },
    data(){
        return {
            localDynamicVar:[]
        }
    },
    computed:{
        ...mapGetters({
          llmContactAttributes: 'attributes/getLLMcontactAttributes',
        }),
        showAppendBtn(){
            return this.localDynamicVar.length < this.llmContactAttributes.length;
        },
    },
    mounted(){
        console.log("Mounting variable modal");
        this.localDynamicVar.push(...this.dataList);
    },
    validations() {
      return {
        localDynamicVar:{
            $each:{
                name: {
                  required,
                },
                value: {
                  required,
                },

            }
        },
      }
    },
    methods:{
        onSave(){
            this.$v.$touch();
            if (this.$v.$invalid) {
                console.log("Error fields");
                return;
            }
            this.$emit('onAddDynamicVariables',this.localDynamicVar);
        },
        getFilteredOptions(index) {
            const selected = this.localDynamicVar
            .map((item, i) => (i !== index ? item?.name : null))
            .filter(Boolean);

            return this.llmContactAttributes.filter(
            (option) => !selected.includes(option?.name)
            );
        },
        appendNewItem(){
            this.localDynamicVar.push(null)
        },
        onDeleteVariable(index){
            this.localDynamicVar.splice(index, 1);
        },
    },
}
</script>

<style lang="scss" scoped>

// .item_selector{
//     display: grid;
//     grid-template-columns: 1fr 1fr 50px;
//     gap: 10px;
// }
// .dataInputfield{
//     margin-top: 0 !important;
// }
.delete_var{
    display: flex;
    justify-content: center;
}
</style>
<style>

/* .dataInputfield{
    margin-top: 0 !important;
} */
</style>

